import { render, staticRenderFns } from "./onay.vue?vue&type=template&id=2fb74a30&"
import script from "./onay.vue?vue&type=script&lang=js&"
export * from "./onay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports